import { ChevronLeft, X } from "./icons";

interface ChatHeaderProps {
  onBack: () => void;
  onClose: () => void;
  showFinish?: boolean;
  onFinish?: () => void;
  isFinishing?: boolean;
}

export function ChatHeader({
  onBack,
  onClose,
}: ChatHeaderProps) {
  return (
    <header className="flex items-center justify-between px-2 py-4">
      <button
        onClick={onBack}
        className="w-10 h-10 flex items-center justify-center text-text-primary"
        aria-label="Go back"
      >
        <ChevronLeft className="w-6 h-6" />
      </button>

      <button
        onClick={onClose}
        className="w-10 h-10 flex items-center justify-center text-text-primary"
        aria-label="Close"
      >
        <X className="w-6 h-6" />
      </button>
    </header>
  );
}
